import Service from '../../services'
import { checkAndReturn } from "../../main"
// import Service from "@/services";

const state = {
    GeneralForm: {},
    ProjectForm: {},
    PlanForm: {},
    OOIForm: {},
    AttachmentForm: {},
    SummaryData: {}
}

const getters = {

}

const actions = {
    getMasterFormB ({ commit }, params) {
        return Service.BForm.getMasterFormB(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },
    getMasterFormBMain ({ commit }, params) {
        return Service.BForm.getMasterFormBMain(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    storeFormB ({ commit }, data) {
        return Service.BForm.storeFormB(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    updateFormB ({ commit }, data) {
        return Service.BForm.updateFormB(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    getFormBList ({ commit }, params) {
        return Service.BForm.getFormBList(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getEditMasterFormB ({ commit }, params) {
        return Service.BForm.getEditMasterFormB(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getEditMasterFormBInception ({ commit }, params) {
        return Service.BForm.getEditMasterFormBInception(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    storeNewProgressFormB ({ commit }, params) {
        return Service.BForm.storeNewProgressFormB(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },
}

const mutations = {
    setGeneralForm (state, val) {
        state.GeneralForm = val
    },
    setProjectForm (state, val) {
        state.ProjectForm = val
    },
    setPlanForm (state, val) {
        state.PlanForm = val
    },
    setOOIForm (state, val) {
        state.OOIForm = val
    },
    setAttachmentForm (state, val) {
        state.AttachmentForm = val
    },
    addSummaryData (state, val) {
        state.SummaryData = {
            ...state.SummaryData,
            ...val
        }
    },
    clearSummaryData (state) {
        state.SummaryData = {}
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
